import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram, Facebook, MessageCircle, Star, ChevronUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  return (
    <footer className="border-t border-slate-100" data-testid="footer">
      <div className="bg-white py-10 sm:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-4 mb-5">
                <img src="/promo/logo40v2-final-semtag.png" alt="Tomaselli" className="h-14 sm:h-16" />
              </div>
              <div className="space-y-2.5">
                {[
                  'Soluções para Eventos (Corporativos, Feiras, Congressos, Shows, Sociais)',
                  'Locação de Equipamentos (Som, Painéis LED, Vídeo, Luz, Info, Estruturas)',
                  'Estúdio de Gravação (Bandas, Produção Musical, Aulas EAD, Áudio Livros)',
                  'Soluções para Instalações Áudio Visuais (Auditórios, Industriais, Treinamentos)',
                  'Projetos Técnicos e Consultoria',
                ].map((s, i) => (
                  <div key={i} className="flex items-start gap-2.5">
                    <Star size={13} className="text-[#5BC0F8] flex-shrink-0 mt-0.5" fill="#5BC0F8" />
                    <span className="text-[#475569] text-sm font-medium leading-snug">{s}</span>
                  </div>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 mt-8 text-[#475569] text-sm font-body">
                <div className="flex items-center gap-2">
                  <Mail size={16} className="text-[#00A8E8] flex-shrink-0" />
                  <span>adm@grupotomaselli.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin size={16} className="text-[#00A8E8] flex-shrink-0" />
                  <span>Rua Santa Quitéria, 261 - Presidente Vargas, Manaus/AM</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-slate-200 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-4">
              <a href="https://instagram.com/grupotomaselli" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram"
                className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-[#475569] hover:text-[#0A2463] hover:border-[#0A2463] transition-all">
                <Instagram size={18} />
              </a>
              <a href="https://wa.me/5592988020092" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-[#475569] hover:text-[#25D366] hover:border-[#25D366] transition-all">
                <MessageCircle size={18} />
              </a>
              <a href="https://facebook.com/grupotomaselli" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook"
                className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-[#475569] hover:text-blue-600 hover:border-blue-600 transition-all">
                <Facebook size={18} />
              </a>
            </div>
            <p className="text-[#94A3B8] text-xs font-body">&copy; {new Date().getFullYear()} Grupo Tomaselli &ndash; Todos os Direitos Reservados.</p>
            <div className="flex items-center gap-4">
              <Link to="/privacidade" className="text-[#94A3B8] hover:text-[#475569] text-xs font-body" data-testid="footer-privacidade">Política de Privacidade</Link>
              <Link to="/admin" className="text-transparent hover:text-[#94A3B8] text-xs font-body" data-testid="footer-admin-link">Admin</Link>
            </div>
          </div>
        </div>
      </div>

      <button onClick={scrollToTop} data-testid="scroll-top-btn"
        className="fixed bottom-6 right-6 w-12 h-12 bg-[#0A2463] hover:bg-[#103487] text-white rounded-xl shadow-lg flex items-center justify-center transition-all z-40 border border-white/10">
        <ChevronUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
